import TitleSection from "../../../../Components/TitleSection/TitleSection"
import { RoutesPaths } from "../../../../constants/user-routes"
import { pagesConfig } from "../../../Layout/pagesConfig"

// §8.2 — support's copy of the Receipt main page carries the merchant's own header:
// card icon, "Receipt", and the subtitle, with "Learn more about Digital Receipt" on
// the right. Business settings suppresses its page header for admins entirely
// (`BusinessSettings/index.js`), so the page has to render this one itself.
//
// The copy is read from the merchant route's entry rather than repeated here, because
// the spec asks for the two pages to match 1:1 — a wording change on one side would
// otherwise silently leave the other behind.
//
// `TitleSection` also renders whatever the page registered in TitleSectionContext,
// which is how the "Learn more" button reaches the admin page at all.
const { title, description, icon } = pagesConfig[RoutesPaths.receipts.all]

// The page already pads itself, so the header only keeps its vertical rhythm.
const FLUSH_WITH_PAGE_PADDING = { padding: 0 }

export const AdminReceiptHeader = ({ usersViewForAdmin }) => {
  if (!usersViewForAdmin) return null

  return (
    <TitleSection
      title={title}
      description={description}
      icon={icon}
      style={FLUSH_WITH_PAGE_PADDING}
    />
  )
}

export default AdminReceiptHeader
